/*
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Box,
	FlatList,
	Icon,
	Pressable,
	Row,
	Text,
} from 'native-base';
import {
	Ionicons,
	FontAwesome5,
} from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import testProps from '../OneHat/functions/testProps';
import withRedux from '../OneHat/data/hoc/withRedux';
import useOneHatData from '../OneHat/data/useOneHatData';
import _ from 'lodash';

function DrawerPagelist(props) {
		const {
				user,
				actions,
			} = props,
			navigation = useNavigation(),
			[users, Users] = useOneHatData('Users'),
			onSelect = (row) => {
				const route = row.item.route;

				// Handle actions
				if (route === 'Logout') {
					logout();
					return;
				}

				// Handle actual navigation
				navigation.navigate(route);
			},
			iconProps = {
				size: 'sm',
				flex: 10,
				pr: 5,
				textAlign: 'center',
				color: '#444',
			},
			pages = [];
	
	// pages.push({ title: 'Home', route: 'Home', icon: <Icon {...iconProps} as={FontAwesome5} name="home" /> });
	// pages.push({ title: 'Setup', route: 'Setup', icon: <Icon {...iconProps} as={FontAwesome5} name="cog" /> });

	pages.push({ title: 'About the Music', route: 'Music', icon: <Icon {...iconProps} as={FontAwesome5} name="itunes-note" /> });
	pages.push({ title: 'About the Catechism', route: 'Catechism', icon: <Icon {...iconProps} as={FontAwesome5} name="book-open" /> });
	pages.push({ title: 'Endorsements', route: 'Endorsements', icon: <Icon {...iconProps} as={FontAwesome5} name="check" /> });
	pages.push({ title: 'FAQ', route: 'Faq', icon: <Icon {...iconProps} as={FontAwesome5} name="comments" /> });
	// pages.push({ title: 'Contact Us', route: 'Contact', icon: <Icon {...iconProps} as={FontAwesome5} name="phone" /> });
	
	pages.push({ title: 'About the App', route: 'About', icon: <Icon {...iconProps} as={FontAwesome5} name="mobile-alt" /> });
	pages.push({ title: 'Privacy Policy', route: 'Privacy', icon: <Icon {...iconProps} as={FontAwesome5} name="user-secret" /> });
	pages.push({ title: 'Terms of Service', route: 'Terms', icon: <Icon {...iconProps} as={FontAwesome5} name="scroll" /> });
	pages.push({ title: 'Utilities', route: 'Utilities', icon: <Icon {...iconProps} as={FontAwesome5} name="tools" /> });

	return <Box>
				<FlatList
					{...testProps('DrawerPagelist')}
					bg="trueGray.200"
					data={pages}
					keyExtractor={entity => entity.route}
					renderItem={(row) => {
						const page = row.item;
						return <Pressable 
									{...testProps('Routes-' + page.route)}
									onPress={() => onSelect(row)}
								>
									<Row
										h={10}
										p={2}
										bgColor="#fff"
										borderBottomWidth={0.5}
										borderBottomColor="#aaa"
									>
										{page.icon}
										<Text flex={90}>{page.title}</Text>
										<Icon active as={FontAwesome5} size="sm" color="#aaa" w={10} ml={2} name="angle-right" />
									</Row>
								</Pressable>;
					}}
				/>
			</Box>;
}

export default withRedux(DrawerPagelist, [
	'user',
]);